import {
  Box,
  Button,
  Card,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import RichTextEditorDialog from "src/components/prize-draw-admin/RichTextEditor";
import PrizeEditModal from "src/components/prize-draw-admin/PrizeEditModal";
import { getUserPermissions } from "src/utils/permissionsUtils";
import { useState } from "react";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1, paddingTop: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const languages = [{ title: 'English', prefix: 'en', index: 0 }, { title: 'French', prefix: 'fr', index: 1 }]


export default function PrizeDrawForm({
  prizeDrawBody,
  setPrizeDrawBody,
  handleDateChange,
  handleChangeStatus,
  fileInputRef,
  handleButtonClick,
  uploadFiles,
  handlePrizeChange,
  handlePrizeSubmit,
  handleRemovePrizeRow,
  handleAddPrizeRow,
  loadingDeletePrizeIds,
  prizeDrawParams,
  prizeLoading,
  winnersMsgRef,
}) {
  const [lang, setLang] = useState(0)
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPrize, setSelectedPrize] = useState(null);
  const dateFormat = "YYYY-MM-DD HH:mm:ss";
  const { isViewer } = getUserPermissions();

  const handleChangeTabs = (event, newLang) => {
    setLang(newLang);
  };

  const handleOpenModal = (prize) => {
    setSelectedPrize(prize);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedPrize(null);
  };

  const handleSavePrize = (editedPrize) => {
    handlePrizeSubmit(editedPrize);
  };

  return (
    <Card sx={{ p: 3 }}>
      <Grid container spacing={2}>
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={lang}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
            >
              {
                languages.map(({title, index}) => (<Tab label={title} {...a11yProps(index)} />))
              }
            </Tabs>
          </Box>
          {
            languages.map(({prefix, index}) => (
              <TabPanel value={lang} index={index} key={prefix}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DateTimePicker
                        label="Start Date"
                        value={moment(prizeDrawBody.startDate, dateFormat)}
                        onChange={(value) =>
                          handleDateChange(value, "startDate")
                        }
                        renderInput={(params) => <TextField fullWidth {...params} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DateTimePicker
                        label="Close Date"
                        value={moment(prizeDrawBody.closeDate, dateFormat)}
                        onChange={(value) => handleDateChange(value, "closeDate")}
                        renderInput={(params) => <TextField fullWidth {...params} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl fullWidth>
                      <InputLabel id="type-select-label">Status</InputLabel>
                      <Select
                        labelId="type-label"
                        id="type-select"
                        value={prizeDrawBody.status}
                        label="tatus"
                        onChange={handleChangeStatus}
                      >
                        <MenuItem disabled={prizeDrawBody.status === 2} value="0">
                          Draft
                        </MenuItem>
                        <MenuItem disabled={prizeDrawBody.status === 2} value="1">
                          Active
                        </MenuItem>
                        <MenuItem value="archived">Archived</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Title"
                      fullWidth
                      variant="standard"
                      value={prizeDrawBody[`title_${prefix}`]}
                      onChange={(e) =>
                        setPrizeDrawBody({ ...prizeDrawBody, [`title_${prefix}`]: e.target.value })
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Subtitle"
                      fullWidth
                      variant="standard"
                      value={prizeDrawBody[`sub_title_${prefix}`] || ""}
                      onChange={(e) =>
                        setPrizeDrawBody({ ...prizeDrawBody, [`sub_title_${prefix}`]: e.target.value })
                      }
                    />
                  </Grid>
                  <Grid container spacing={2} sx={{ mt: 2, ml: 1 }}>
                    <Grid item xs={12} sm={4}>
                      <Stack spacing={2}>
                        {prizeDrawBody.image_en ? (
                          <img
                            src={prizeDrawBody.image_en}
                            alt="Prize"
                            style={{
                              width: "237px",
                              height: "237px",
                              borderRadius: "1px",
                            }}
                          />
                        ) : (
                          <Box
                            sx={{
                              width: 237,
                              height: 237,
                              borderRadius: 1,
                              backgroundColor: "#f0f0f0",
                            }}
                          />
                        )}

                        <Button
                          onClick={handleButtonClick}
                          variant="outlined"
                          sx={{ width: "50%" }}
                        >
                          Upload Image
                        </Button>
                        <input
                          type="file"
                          accept="image/*"
                          hidden
                          ref={fileInputRef}
                          onChange={uploadFiles}
                        />
                      </Stack>
                    </Grid>
                  </Grid>

                  <Grid item xs={10} sx={{ mt: 4, p: 1 }}>
                    {prizeDrawBody?.prizes?.map((row, index) => (
                      <Stack
                        direction="row"
                        spacing={2}
                        mb={2}
                        key={row.id}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          p: 2,
                          border: "1px solid #e0e0e0",
                          borderRadius: 1,
                        }}
                      >
                        <Box sx={{ flex: 1 }}>
                          <Typography variant="subtitle2">
                            {row[`title_${prefix}`] || "Untitled Prize"}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Tickets: {row.tickets || 0}
                          </Typography>
                        </Box>
                        <Stack direction="row" spacing={1}>
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => handleOpenModal(row)}
                          >
                            Edit
                          </Button>
                          {!isViewer && (
                            <IconButton
                              disabled={loadingDeletePrizeIds.includes(row.id)}
                              onClick={() => handleRemovePrizeRow(row.id)}
                              size="small"
                            >
                              <img
                                src={"/assets/icons/delete-row.svg"}
                                alt="Delete"
                                style={{ width: 20, height: 20 }}
                              />
                            </IconButton>
                          )}
                        </Stack>
                      </Stack>
                    ))}
                    <Stack sx={{ mt: 4 }} direction="row" spacing={1} alignItems="center">
                      <img
                        src="/assets/icons/plus-circle.svg"
                        alt="Add"
                        style={{ width: 16, height: 16 }}
                      />
                      <Button onClick={handleAddPrizeRow} sx={{ p: 0 }}>
                        {" "}
                        Add New Prize Row
                      </Button>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} sx={{ mt: 4 }}>
                    <Typography variant="subtitle1" sx={{ mb: 1 }}>
                      Inbox Winners Message
                    </Typography>
                    <RichTextEditorDialog
                      editorRef={winnersMsgRef}
                      value={prizeDrawBody.winnersMessage}
                      onChange={(html) =>
                        setPrizeDrawBody((prev) => ({
                          ...prev,
                          winnersMessage: html,
                        }))
                      }
                      fieldName="winnersMessage"
                    />
                  </Grid>
                  <Grid item xs={12} sx={{ mt: 4 }}>
                    <TextField
                      label="Max Ticket Entry per user (optional)"
                      fullWidth
                      variant="standard"
                      value={prizeDrawBody.maxTicket}
                      onChange={(e) =>
                        setPrizeDrawBody({
                          ...prizeDrawBody,
                          maxTicket: e.target.value,
                        })
                      }
                    />
                  </Grid>
                </Grid>
              </TabPanel>
            ))
          }
        </Box>
      </Grid>

      <PrizeEditModal
        open={modalOpen}
        onClose={handleCloseModal}
        prize={selectedPrize}
        onSave={handleSavePrize}
        prizeDrawParams={prizeDrawParams}
        prizeLoading={prizeLoading}
      />
    </Card>
  );
}
